export default "__VITE_ASSET__D43R$emC__"